(function ($) {
  $(".share-btn").on("click", function () {
    const val = $(this).attr("data");
    $(`#share-fade-${val}`).fadeToggle();
  });
})(jQuery);
